//////////////////////////////// sidebar ////////////////////////////////
function sidebar() {
  toggleSidebar(false);
  $('#sidebarCollapse').on('click', function() {
    toggleSidebar(true);
  });
}

function toggleSidebar(toggle) {
  var minimized = toggle ? !$('.sidebar').hasClass('sidebar-minimized') : $('.sidebar').hasClass('sidebar-minimized');
  $('.sidebar, .content').toggleClass('sidebar-minimized', minimized);
  if (toggle) Cookies.set('sidebar_off', minimized);
  setTimeout(function() {
    $('body').trigger('table:resize')
  }, 0)
}

/////////////////////////////// Flash Messages //////////////////////////
function showFlashMessage(type, text, timeout, place) {
  'use strict';

  if (typeof(type) === 'undefined') {
    type = 'info';
  }
  if (typeof(text) === 'undefined') {
    text = '';
  }

  if(typeof(place) === "undefined") {
    place = $('#messages')
  }

  var $alert = $(
    '<div class="alert alert-' + type + ' alert-dismissible fade show" role="alert">' +
    text +
    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
    '</div>');

  place.append($alert);
  if (typeof(timeout) !== 'undefined') {
    setTimeout(function() {
      $alert.slideUp({
        duration: 300,
        done: function() {
          $alert.remove();
        }
      });
    }, timeout);
  }
}

//////////////////////////////// anchor fix ////////////////////////////
function anchorFix() {
  var href = window.location.hash;
  if (href) {
    href = decodeURIComponent(href).slice(2);
    var $elem = $('[id='+href+']');
    if ($elem.length) {
      setTimeout(function () {
        $("html, body").scrollTop($elem.position().top);
      }, 600)
    }
  }
}

//////////////////////////// intervals checks //////////////////////////////////
function testOverlaps(block, errorText, strictTest = true) {
  let testOverlapsCallback = function(ev, picker) {
    let interval = moment.range(picker.startDate.startOf('day'), picker.endDate.startOf('day'));
    let error = false;
    block.find('.picker').each(function () {
      let elem = $(this).data('daterangepicker');
      let startD = elem.startDate.startOf('day');
      let endD = elem.endDate.startOf('day');

      let bad = (elem !== picker) && interval.overlaps(moment.range(startD, endD), {adjacent: strictTest});

      $(this).find('input').toggleClass('is-invalid', bad);
      error = error || bad;
    });
    block.find('.warning-block').toggleClass('d-none', !error).find('.warning-text').html(errorText);
  }

  block.on('apply.daterangepicker', '.picker', testOverlapsCallback
  ).on('change', '.picker input', function(ev) {
    let pickerElement = $(this).closest('.picker');
    if (pickerElement) {
      let picker = pickerElement.data('daterangepicker');
      picker.setStartDate(pickerElement.find('input:first').val());
      picker.setEndDate(pickerElement.find('input:last').val());
      testOverlapsCallback(ev, picker);
    }
  });
}

function testGaps(block, testInterval, errorText, strictTest = true) {
  let testGapsCallback = function(ev, picker) {
    let error = false;
    let last = null;

    let testDates = block.find('.picker').map (function(i, el) {
      let disabledEl = $(el).closest('.row').find('input[id$="_destroy"][value="1"]');
      if (disabledEl.length > 0) {
        return null; // kontrolujeme len tie, co sa nebudu mazat
      }
      const elem = $(el).data('daterangepicker');
      return {
        elem: el,
        startD: moment(elem.startDate).startOf('day'),
        endD: moment(elem.endDate).startOf('day')
      }
    }).filter(function (el) {
      return el != null;
    }).sort(function(elem1, elem2) {
      return elem1.startD.valueOf() - elem2.startD.valueOf();
    });

    testDates.each(function(i, item) {
      let bad = last ? last.format() !== moment(item.startD).subtract(strictTest ? 1 : 0, 'days').format() : false;
      last = moment(item.endD);
      $(item.elem).find('input').toggleClass('is-invalid', bad);
      error = error || bad;
    });

    if (testInterval && testDates.length > 0) {
      let elemTest = $(testInterval).find('.picker')[0];
      elemTest = $(elemTest).data('daterangepicker');
      if (elemTest) {
        if (testDates[0].startD.valueOf() > moment(elemTest.startDate).startOf('day').valueOf()) {
          error = true;
          $(testDates[0].elem).find('input').toggleClass('is-invalid', true);
        }
        if (testDates[testDates.length - 1].endD.valueOf() < moment(elemTest.endDate).startOf('day').valueOf()) {
          error = true;
          $(testDates[testDates.length - 1].elem).find('input').toggleClass('is-invalid', true);
        }
      }
    }

    block.find('.warning-block').toggleClass('d-none', !error).find('.warning-text').html(errorText);
    $('input[type="submit"]').attr('disabled', error);
  }

  if (testInterval) {
    testInterval.on('apply.daterangepicker', '.picker', testGapsCallback)
  }

  block.on('apply.daterangepicker', '.picker', testGapsCallback
  ).on('change', '.picker input', function(ev) {
    // let picker = $(this).closest('.picker').data('daterangepicker');
    let pickerElement = $(this).closest('.picker');
    if (pickerElement) {
      let picker = pickerElement.data('daterangepicker');
      picker.setStartDate(pickerElement.find('input:first').val());
      picker.setEndDate(pickerElement.find('input:last').val());
      testGapsCallback(ev, picker);
    }
  }).on('cocoon:after-remove', function(ev, deletedItem) {
    let elem = deletedItem.find('.picker').data('daterangepicker');
    testGapsCallback(ev, elem);
  });
}

//////////////////////////////// nested ////////////////////////////

function chceckNestedStates(elems) {
  elems.forEach(function (elem) {
    let count = $('.nested-body .nested-fields.add-' + elem.id).find('input[id$="_destroy"][value="false"]').length;
    $('.nested-body .btn.add-' + elem.id).toggleClass('disabled', count >= elem.max);
  })
}

function toggleMaxNested(elems) {
  $('.nested-body').on('cocoon:after-insert', function() {
    chceckNestedStates(elems);
  }).on('cocoon:after-remove', function() {
    chceckNestedStates(elems);
  });

  chceckNestedStates(elems);
}

//////////////////////////////// sortable.js ////////////////////////////
function sortable() {
  $('.move-table tbody').each(function(i, el) {
    Sortable.create(el, {
      handle: '.move-row',
      // filter: '.fa-edit',
      animation: 150,
      ghostClass: 'ghost',
      group: $(el).attr('id'),
      onUpdate: function(evt) {
        $.ajax({
          method: 'PUT',
          url: $(evt.item).data('move'),
          data: { pos: (evt.newIndex + 1) },
          dataType: 'json',
          error: function() {
            console.error(e);
          },
          success: function() {
            var target = $('.move-row');
            $(el).closest('table').addClass('sort-success');

            setTimeout(function() {
              $(el).closest('table').removeClass('sort-success');
            }, 1500);
          }
        });
      }
    });
  });
}

function initDataTables(location) {
  $(location).each(function() {
    const elem = $(this);
    const loc = elem.data('loc');
    const tableType = elem.data('table-type');
    const unorderedCols = elem.data('unordered-cols') || [];
    const orderedCols = elem.data('ordered-cols') || [];
    const pageSize = elem.data('page-size');
    let options = {
      order: [],
      searching: true,
      stateSave: false,
      language: dataLang[loc],
      deferRender: true,
      // responsive: true
    }
    if (tableType === 'evaluations') {
      Object.assign(options, {
        lengthChange: false,
        columnDefs: [
          { orderable: false, targets: unorderedCols },
          { type: loc === "cs" ? "czech" : "english", targets: orderedCols }
        ]
      })
      if (pageSize) {
        options['pageLength'] = pageSize;
      } else {
        options['paging'] = false;
      }
    } else {
      Object.assign(options, {
        lengthChange: true,
        lengthMenu: [ [10, 20, 50, 100, -1], [10, 20, 50, 100, loc === "cs" ? "Vše" : "All"] ],
        pageLength: 20,
        columnDefs: [{ type: loc === "cs" ? "czech" : "english", targets: orderedCols }],
        // responsive:  true,
        fixedHeader: true
      })
    }
    elem.DataTable(options);
  });
}

function initSelect2(location) {
  $(location).each(function() {
    const elem = $(this);
    const lang = elem.data('loc') || "cs";
    const url = elem.data('url');
    const clear = elem.data('clear');
    let options = {
      language: lang,
      theme: 'bootstrap4'
    };
    if (url) {
      Object.assign(options, {
        minimumInputLength: 1,
        ajax: {
          url: url,
          dataType: 'json',
          delay: 200,
          processResults: function(data) {
            // console.log(`Incoming: ${data}`);
            return {
              results: $.map(data, function (tuple, idx) {
                // console.log(`Element: ${tuple}`);
                return {text: tuple[0], id: tuple[1]}
              })
            }
          }
        }
      });
      if (clear) {
        Object.assign(options, {
          allowClear: true,
          placeholder: ''
        });
      }
    } else {
      Object.assign(options, {
        allowClear: true,
        placeholder: ''
      });
    }
    elem.select2(options);
  });
}

///////////////////////// Daterangepicker.js ////////////////////////
function initDatePickers(location) {
  'use strict';

  $(location).each(function() {
    dateTimePicker($(this));
  });
}

function dateTimePicker($elem) {
  'use strict';

  var locales = {
    cs: {
      config: {
        firstDay: 1,
        applyLabel: 'Použít',
        cancelLabel: 'Smazat',
        fromLabel: 'Od',
        toLabel: 'Do',
        customRangeLabel: 'Vlastní',
        monthNames: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'],
        daysOfWeek: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        weekLabel: 'T'
      },
      ranges: {
        'Dnes': [moment().startOf('day'), moment().endOf('day')],
        'Včera': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Posledních 7 dní': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
        'Posledních 30 dní': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
        'Tento měsíc': [moment().startOf('month'), moment().endOf('month')],
        'Minulý měsíc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    },
    en: {
      config: {
        firstDay: 0,
        applyLabel: 'Apply',
        cancelLabel: 'Clear',
        fromLabel: 'From',
        toLabel: 'To',
        customRangeLabel: 'Custom',
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        weekLabel: 'W'
      },
      ranges: {
        'Today': [moment().startOf('day'), moment().endOf('day')],
        'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
        'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    }
  };

  var elemName = $elem.data('picker-name');
  var showRange = $elem.data('picker-range');
  var customRanges = $elem.data('picker-show-ranges');
  var showWeeks = $elem.data('picker-show-weeks');
  var onlyDate = $elem.data('picker-only-date');
  var position = $elem.data('picker-position');
  var minDate = $elem.data('picker-min-date');
  var maxDate = $elem.data('picker-max-date');
  var maxSpan = $elem.data('picker-max-span');
  var drops = $elem.data('picker-drops');
  var lang = $elem.data('picker-lang') || 'cs'; // TODO: ne default cestina

  var pickerFormat = lang === 'cs' ? (onlyDate ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm') : (onlyDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm');
  var $elemFrom, dateFrom, $elemTo, dateTo;

  if (showRange) {
    $elemFrom = $elem.find('[name$="[' + $elem.data('picker-from') + ']"]:not([disabled])');
    dateFrom = $elemFrom.val();
    $elemTo = $elem.find('[name$="[' + $elem.data('picker-to') + ']"]:not([disabled])');
    dateTo = $elemTo.val();
  } else {
    $elemFrom = $elem.find('[name$="[' + elemName + ']"]:not([disabled])');
    dateFrom = $elemFrom.val();
  }
  var options = {
    singleDatePicker: !showRange,
    autoApply: false,
    opens: position,
    drops: drops,
    autoUpdateInput: true,
    linkedCalendars: false,
    // linkedCalendars: true,
    showDropdowns: true,
    alwaysShowCalendars: false,
    locale: locales[lang]['config'],
    applyButtonClasses: 'btn-primary',
    cancelButtonClasses: 'btn-secondary',
    showWeekNumbers: showWeeks
  };
  if (minDate) {
    options.minDate = moment(minDate);
  }
  if (maxDate) {
    options.maxDate = moment(maxDate);
  }
  if (maxSpan) {
    options.maxSpan = { days: maxSpan };
  }
  options.locale.format = pickerFormat;
  options.invalidDates = $elemFrom.data('disabled-days') ? $elemFrom.data('disabled-days').split('|') : [];
  options.invalidIntervals = $elemFrom.data('disabled-intervals') ? $elemFrom.data('disabled-intervals') : [];
  if (!onlyDate) {
    options.timePicker = true;
    options.timePicker24Hour = true;
    // options.timePickerIncrement = 10;
  }
  if (showRange && customRanges) {
    options.ranges = locales[lang]['ranges'];
  }
  if (dateFrom) {
    options.startDate = dateFrom;
  }
  if (showRange && dateTo) {
    options.endDate = dateTo;
  }
  options.isInvalidDate = function(date) {
    if (options.invalidDates.includes(date.format('YYYY-MM-DD')))
      return true;

    return options.invalidIntervals.reduce(function (out, item) {
      return out || date.isBetween(item.from, item.till, 'day', '[]');
    }, false);
  };

  function toggleCalendarButtons(show = false) {
    if ($elem.find('.calendar-toggle-btn').length) {
      $elem.find('*').toggleClass('hidden-block', show);
      $elem.find('.calendar-toggle-btn').toggleClass('hidden-block', !show);
    }
  }

  function syncPickerFromInputs(picker) {
    var fromVal = $elemFrom.val();
    var fromMoment = fromVal ? moment(fromVal, pickerFormat, true) : null;
    if (!(fromMoment && fromMoment.isValid())) return;

    picker.setStartDate(fromMoment);

    if (!showRange) return;

    var toVal = $elemTo.val();
    var toMoment = toVal ? moment(toVal, pickerFormat, true) : null;
    // Valid range only when end is present and not before start; otherwise highlight start only
    if (toMoment && toMoment.isValid() && !toMoment.isBefore(fromMoment, 'day')) {
      picker.setEndDate(toMoment);
    } else {
      picker.endDate = null;
    }
  }

  function syncInputsFromPicker(picker) {
    if (!picker.startDate) return;

    $elemFrom.val(picker.startDate.format(pickerFormat));
    if (showRange) {
      if (picker.endDate) {
        $elemTo.val(picker.endDate.format(pickerFormat));
      } else {
        // Mid-select from calendar: clear stale end so inputs match highlight
        $elemTo.val('');
      }
    }
  }

  var selectingFromCalendar = false;

  $elem.daterangepicker(options)
    .on('show.daterangepicker', function(ev, picker) {
      selectingFromCalendar = false;
      syncPickerFromInputs(picker);
      picker.oldStartDate = picker.startDate.clone();
      picker.oldEndDate = picker.endDate ? picker.endDate.clone() : picker.startDate.clone();
      picker.updateView();
    })
    .on('hide.daterangepicker', function(ev, picker) {
      // Only rewrite inputs after calendar interaction (incomplete select reverts inside hide)
      if (selectingFromCalendar && picker.startDate) {
        syncInputsFromPicker(picker);
      }
      selectingFromCalendar = false;
    })
    .on('apply.daterangepicker', function(ev, picker) {
      toggleCalendarButtons(false);
      syncInputsFromPicker(picker);
    })
    .on('cancel.daterangepicker', function(ev, picker) {
      toggleCalendarButtons(true);
      $elemFrom.val('');
      if (showRange) {
        $elemTo.val('');
      }
    });

  var picker = $elem.data('daterangepicker');
  if (picker) {
    // Keep dual inputs aligned with calendar selection before Apply
    picker.container.on('mousedown.daterangepicker', 'td.available', function() {
      selectingFromCalendar = true;
      setTimeout(function() { syncInputsFromPicker(picker); }, 0);
    });
  }
  if ($elem.data('calId') && picker) {
    picker.container.addClass($elem.data('calId'));
  }

  // Manual typing: if calendar is open, re-highlight to match inputs
  var $manualInputs = showRange ? $elemFrom.add($elemTo) : $elemFrom;
  $manualInputs.on('change input', function() {
    var openPicker = $elem.data('daterangepicker');
    if (openPicker && openPicker.isShowing) {
      syncPickerFromInputs(openPicker);
      openPicker.updateView();
    }
  });

  toggleCalendarButtons(!Boolean(dateFrom && dateTo));
}

///////////////////////// fullCalendar.js ////////////////////////
function eventCalendars() {
  $('.event-calendar').each(function() {
    var el = $(this);
    el.fullCalendar({
      events: el.data('url'),
      locale: el.data('loc'),
      header: {
        left: 'title',
        right: 'month,listMonth'
      },
      footer: {
        left: 'prev,next today',
        right: 'prevYear,nextYear'
      },
      // TODO: nejak nefunguje
      // views: {
      //   month: {
      //     displayEventEnd: false
      //   },
      //   listWeek: {
      //     displayEventEnd: false
      //   }
      // },
      themeSystem: 'bootstrap4',
      themeName: 'sandstone',
      bootstrapFontAwesome: {
        close: 'fa-times',
        prev: 'fa-angle-left',
        next: 'fa-angle-right',
        prevYear: 'fa-angles-left',
        nextYear: 'fa-angles-right'
      },
      height: 'parent',
      eventTextColor: '#000',
      eventRender: function(event, element, view) {
        if (view.type === 'month') {
          element.popover({
            title: event.note,
            content: event.title + event.desc,
            trigger: 'hover',
            placement: 'bottom',
            container: 'body',
            delay: { show: 200, hide: 100 },
            animation: true,
            html: true
          });
        }
      }
    });
  });
}

function clearCalendars() {
  $('.event-calendar').each(function() {
    $(this).fullCalendar('destroy');
    $(this).html('');
  });
}

function disableAutofill() {
  if (Cookies.get('disable_autofill') === 'true') {
    $(".simple_form input:not([type=radio], [type=checkbox])").each(function () {
      $(this).focus(function () {
        $(this).data("ninja-name", $(this).attr("name")).attr("name", "");
      }).blur(function () {
        $(this).attr("name", $(this).data("ninja-name"));
      });
    });
    $(".simple_form").submit(function (event) {
      $(this).find("input[name='']").each(function () {
        $(this).attr("name", $(this).data("ninja-name"));
      });
    });
  }
}
///////////////////////// tagsinput + typeahead.js ////////////////////////
function tagsInputTypeAhead() {
  const inputs = $('.tagsinput');
  inputs.each(function (_index, input) {
    const wrapped = $(input);
    const attribute = wrapped.attr('data-typeahead-source');
    if (attribute) {
      const data = JSON.parse(attribute);
      const tags = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('tag'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        local: data
      });
      wrapped.tagsinput({
        confirmKeys: [13, 32, 44],
        typeaheadjs: {
          name: 'congress_tags',
          displayKey: 'tag',
          valueKey: 'tag',
          source: tags
        }
      });
    }
  })
}

function syncNewFilterTable() {
  $('.table.filter-table').closest('.filter-table-block').each((_index, element) => {
    const $block = $(element).addClass('new-filter-table')
    const labelsHeight = $block.find('thead tr').first().outerHeight() || 54
    $block.css('--labels-row-height', `${labelsHeight}px`)
  })
}

function initNewFilterTable() {
  syncNewFilterTable()

  if (initNewFilterTable.bound) {
    return
  }

  initNewFilterTable.bound = true
  $(document).on('turbo:load', syncNewFilterTable)
  $(window).on('resize', syncNewFilterTable)
}
// ============================================================================
// Global exports — required for inline <script> tags in views that call these
// functions directly. esbuild's IIFE format scopes module declarations; this
// block re-attaches them to window so they remain accessible like they were
// in the old Sprockets global-scope setup.
// ============================================================================
window.sidebar            = sidebar
window.toggleSidebar      = toggleSidebar
window.showFlashMessage   = showFlashMessage
window.anchorFix          = anchorFix
window.testOverlaps       = testOverlaps
window.testGaps           = testGaps
window.chceckNestedStates = chceckNestedStates
window.toggleMaxNested    = toggleMaxNested
window.sortable           = sortable
window.initDataTables     = initDataTables
window.initSelect2        = initSelect2
window.initDatePickers    = initDatePickers
window.dateTimePicker     = dateTimePicker
window.eventCalendars     = eventCalendars
window.clearCalendars     = clearCalendars
window.disableAutofill    = disableAutofill
window.tagsInputTypeAhead = tagsInputTypeAhead
window.initNewFilterTable = initNewFilterTable
